import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { MarketingCard } from 'common';
import { RequestMarketingCardContentSelector } from './RequestMarketingCardContentSelector';
import { fetchRequestMarketingCard } from './RequestMarketingCardSlice';

export function useRequestMarketingCard(): AbstractContentState<MarketingCard[]> {
    return useCmsContent(fetchRequestMarketingCard, RequestMarketingCardContentSelector);
}
